import { render } from "./levelManage.vue?vue&type=template&id=37a7c4db&ts=true"
import script from "./levelManage.vue?vue&type=script&lang=ts"
export * from "./levelManage.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__